import { ChangeEvent, FocusEvent } from 'react';
import {
  Box,
  CircularProgress,
  MenuItem,
  FormControl,
  Select,
  FormHelperText,
  Typography,
} from '@material-ui/core';
import ErrorRoundedIcon from '@material-ui/icons/ErrorRounded';

interface FormSelectProps {
  id: string;
  label: string;
  value: string;

  onChange: (event: ChangeEvent<{ name?: string; value: unknown }>) => void;
  onBlur: (event: FocusEvent<any>) => void;
  options: readonly string[] | readonly { label: string; value: string }[];

  placeholder?: string;
  disabled?: boolean;
  error?: string;
  required?: boolean;
  hasNoData?: boolean;
  loading?: boolean;
}

export const FormSelect = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  options,
  placeholder,
  disabled = false,
  error,
  required,
  hasNoData = false,
  loading = false,
}: FormSelectProps) => {
  return (
    <Box className="apm-form-group">
      <Typography component="label" htmlFor={id} className="apm-form-label">
        {label}
        {required && <span className="apm-required">*</span>}
      </Typography>
      <FormControl
        variant="outlined"
        size="small"
        fullWidth
        error={Boolean(error) || hasNoData}
        disabled={disabled}
      >
        <Box className="apm-select-wrapper">
          <Select
            className="apm-select-control"
            id={id}
            name={id}
            value={value}
            onChange={onChange}
            onBlur={event => {
              if (options.length === 0) return;
              onBlur(event);
            }}
            displayEmpty
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              getContentAnchorEl: null,
            }}
          >
            <MenuItem value="" disabled>
              {placeholder || 'Select an option'}
            </MenuItem>
            {options.map(option => (
              <MenuItem
                key={typeof option === 'string' ? option : option.value}
                value={typeof option === 'string' ? option : option.value}
              >
                {typeof option === 'string' ? option : option.label}
              </MenuItem>
            ))}
          </Select>
          {loading ? (
            <CircularProgress className="apm-select-spinner" size={20} />
          ) : null}
        </Box>
        {error && (
          <FormHelperText className="apm-field-error">
            <ErrorRoundedIcon className="apm-field-error-icon" />
            {error}
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};
